import React, { useEffect, useState } from "react";

import { useGetConfirmedQuery } from "../../redux/slices/ConfirmedApiSlice";

import { setConfirmed } from "../../redux/slices/confirmedSlice";

import { useDispatch } from "react-redux";

import axios from "axios";

import {
    FaCheckCircle,
    FaExclamationTriangle,
    FaRedo,
    FaSpinner,
    FaBoxOpen,
    FaTimes,
} from "react-icons/fa";

const Confirmed = () => {
    const dispatch = useDispatch();

    const {
        data,
        isLoading,
        isError,
        error: confirmedError,
        refetch,
    } = useGetConfirmedQuery();

    const [userPayments, setUserPayments] = useState({});
    const [searchTerm, setSearchTerm] = useState("");
    const [openPoct, setOpenPoct] = useState(null);

    const [paymentLoading, setPaymentLoading] = useState({});
    const [paymentErrors, setPaymentErrors] = useState({});

    const [generalError, setGeneralError] = useState("");

    const getErrorMessage = (error) => {
        const serverMessage =
            error?.response?.data?.message ||
            error?.response?.data?.error ||
            error?.data?.message ||
            error?.data?.error;

        if (serverMessage) {
            return serverMessage;
        }

        if (error?.response?.status === 400) {
            return "Göndərilən məlumatlar düzgün deyil. Zəhmət olmasa, məlumatları yoxlayın və yenidən cəhd edin.";
        }

        if (error?.response?.status === 401) {
            return "Sessiyanız başa çatıb. Zəhmət olmasa, hesabınıza yenidən daxil olun.";
        }

        if (error?.response?.status === 403) {
            return "Bu məlumatlara baxmaq üçün icazəniz yoxdur.";
        }

        if (error?.response?.status === 404) {
            return "Tələb olunan məlumat tapılmadı.";
        }

        if (error?.response?.status === 429) {
            return "Çox sayda sorğu göndərildi. Bir qədər gözləyib yenidən cəhd edin.";
        }

        if (error?.response?.status >= 500) {
            return "Serverdə texniki problem baş verdi. Zəhmət olmasa, bir qədər sonra yenidən cəhd edin.";
        }

        if (
            error?.code === "ERR_NETWORK" ||
            error?.message?.toLowerCase()?.includes("network")
        ) {
            return "Serverə qoşulmaq mümkün olmadı. İnternet bağlantınızı və serverin işlək vəziyyətdə olduğunu yoxlayın.";
        }

        if (error?.message) {
            return error.message;
        }

        return "Naməlum xəta baş verdi. Zəhmət olmasa, yenidən cəhd edin.";
    };

    useEffect(() => {
        if (!data) return;

        try {
            dispatch(setConfirmed(data));
        } catch (error) {
            console.error("Təsdiqlənmiş sifarişlərin Redux-a yazılması zamanı xəta:", error);
        }

        setGeneralError("");
        setPaymentErrors({});

        data.forEach((cart) => {
            const confirmedCartId = cart?._id;

            if (!confirmedCartId) {
                return;
            }

            setPaymentLoading((prev) => ({
                ...prev,
                [confirmedCartId]: true,
            }));

            axios
                .get(
                    `${process.env.REACT_APP_API_BASE_URL}/api/payment/paymentId/${confirmedCartId}`,
                    {
                        withCredentials: true,
                    }
                )
                .then((response) => {
                    if (
                        response.data &&
                        Object.keys(response.data).length > 0
                    ) {
                        setUserPayments((prev) => ({
                            ...prev,
                            [confirmedCartId]: response.data,
                        }));
                    } else {
                        setPaymentErrors((prev) => ({
                            ...prev,
                            [confirmedCartId]:
                                "Bu sifariş üçün ödəniş məlumatı tapılmadı.",
                        }));
                    }
                })
                .catch((error) => {
                    console.error(
                        `Ödəniş məlumatlarının yoxlanılması zamanı xəta: ${confirmedCartId}`,
                        error
                    );

                    setPaymentErrors((prev) => ({
                        ...prev,
                        [confirmedCartId]: getErrorMessage(error),
                    }));
                })
                .finally(() => {
                    setPaymentLoading((prev) => ({
                        ...prev,
                        [confirmedCartId]: false,
                    }));
                });
        });
    }, [data, dispatch]);

    useEffect(() => {
        if (isError) {
            setGeneralError(getErrorMessage(confirmedError));
        }
    }, [isError, confirmedError]);

    const filteredCarts = (data || []).filter((cart) => {
        return cart?.orderCode
            ?.toString()
            .toLowerCase()
            .includes(searchTerm.trim().toLowerCase());
    });

    const isAnyPaymentLoading = Object.values(paymentLoading).some(
        (value) => value === true
    );

    const handleRetry = async () => {
        setGeneralError("");
        setUserPayments({});
        setPaymentErrors({});
        setPaymentLoading({});

        try {
            await refetch();
        } catch (error) {
            setGeneralError(getErrorMessage(error));
        }
    };

    return (
        <div className="max-w-7xl mx-auto bg-white dark:bg-gray-900 px-4 py-12">
            {/* BAŞLIQ */}
            <div className="mb-10 text-center">
                <div className="flex items-center justify-center gap-3 mb-3">
                    <FaCheckCircle className="text-green-500 text-3xl" />

                    <h1 className="text-4xl font-extrabold text-gray-800 dark:text-white">
                        Təsdiqlənmiş sifarişlər
                    </h1>
                </div>

                <p className="text-gray-500 dark:text-gray-400">
                    Təsdiqlənmiş sifarişlərinizi və ödəniş məlumatlarınızı
                    buradan izləyə bilərsiniz.
                </p>
            </div>

            {/* AXTARIŞ */}
            <div className="mb-10 max-w-2xl mx-auto flex flex-col sm:flex-row items-center gap-4 sm:gap-6 bg-white dark:bg-gray-900 p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700">
                <input
                    type="text"
                    placeholder="Sifariş koduna görə axtarın..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="flex-1 w-full px-4 py-3 text-base border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm dark:bg-gray-800 dark:text-white focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
                />
            </div>

            {/* ÜMUMİ XƏTA */}
            {generalError && (
                <div className="max-w-3xl mx-auto mb-10 rounded-2xl border border-red-200 dark:border-red-900 bg-red-50 dark:bg-red-950/30 p-6">
                    <div className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-11 h-11 rounded-full bg-red-100 dark:bg-red-900/40 flex items-center justify-center">
                            <FaExclamationTriangle className="text-red-600 dark:text-red-400 text-xl" />
                        </div>

                        <div className="flex-1">
                            <h2 className="text-lg font-bold text-red-800 dark:text-red-300">
                                Sifarişlər yüklənmədi
                            </h2>

                            <p className="mt-2 text-sm text-red-700 dark:text-red-300">
                                Təsdiqlənmiş sifarişlərin alınması zamanı problem
                                yarandı.
                            </p>

                            <div className="mt-4 p-4 rounded-xl bg-white dark:bg-gray-900 border border-red-200 dark:border-red-800">
                                <p className="text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1">
                                    Xətanın səbəbi:
                                </p>

                                <p className="text-sm text-gray-600 dark:text-gray-400 break-words">
                                    {generalError}
                                </p>
                            </div>

                            <button
                                type="button"
                                onClick={handleRetry}
                                disabled={isLoading}
                                className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-red-600 hover:bg-red-700 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold transition"
                            >
                                {isLoading ? (
                                    <>
                                        <FaSpinner className="animate-spin" />
                                        Yenidən yoxlanılır...
                                    </>
                                ) : (
                                    <>
                                        <FaRedo />
                                        Yenidən yoxla
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ƏSAS YÜKLƏNMƏ VƏZİYYƏTİ */}
            {isLoading ? (
                <div className="max-w-3xl mx-auto">
                    <div className="flex flex-col items-center justify-center py-16 px-6 rounded-2xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                        <FaSpinner className="text-4xl text-green-600 animate-spin mb-5" />

                        <h2 className="text-xl font-bold text-gray-800 dark:text-white">
                            Sifarişlər yüklənir...
                        </h2>

                        <p className="mt-2 text-center text-gray-500 dark:text-gray-400">
                            Təsdiqlənmiş sifarişləriniz hazırlanır. Zəhmət
                            olmasa, gözləyin.
                        </p>
                    </div>
                </div>
            ) : generalError ? null : filteredCarts?.length > 0 ? (
                <>
                    {/* ÖDƏNİŞLƏR YOXLANILIR */}
                    {isAnyPaymentLoading && (
                        <div className="mb-8 rounded-2xl border border-blue-200 dark:border-blue-900 bg-blue-50 dark:bg-blue-950/30 p-5">
                            <div className="flex items-center gap-3">
                                <FaSpinner className="text-blue-600 dark:text-blue-400 animate-spin text-xl" />

                                <div>
                                    <p className="font-semibold text-blue-800 dark:text-blue-300">
                                        Ödəniş məlumatları yoxlanılır...
                                    </p>

                                    <p className="text-sm text-blue-700 dark:text-blue-400 mt-1">
                                        Sifarişləriniz üzrə ödəniş məlumatları
                                        yoxlanılır. Zəhmət olmasa, gözləyin.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* NƏTİCƏ SAYI */}
                    <div className="mb-6 flex items-center justify-between gap-4">
                        <p className="text-sm text-gray-500 dark:text-gray-400">
                            {filteredCarts.length} sifariş göstərilir
                        </p>

                        {searchTerm && (
                            <p className="text-sm text-gray-500 dark:text-gray-400">
                                Axtarış:
                                <span className="font-semibold text-gray-800 dark:text-gray-200 ml-1">
                                    "{searchTerm}"
                                </span>
                            </p>
                        )}
                    </div>

                    {filteredCarts.map((cart) => {
                        const paymentArray = userPayments[cart?._id];

                        const products = Array.isArray(cart?.products)
                            ? cart.products
                            : [];

                        const productTotal = products.reduce(
                            (acc, product) => {
                                const price = Number(product?.price) || 0;
                                const quantity =
                                    Number(product?.quantity) || 0;

                                return acc + price * quantity;
                            },
                            0
                        );

                        let poctFee = 0;

                        if (
                            paymentArray &&
                            paymentArray.length > 0 &&
                            paymentArray[0]?.poct
                        ) {
                            const match =
                                paymentArray[0].poct.match(
                                    /(\d+(?:\.\d+)?)\s*AZN/
                                );

                            if (match) {
                                poctFee = parseFloat(match[1]);
                            }
                        }

                        const totalWithPoct = (
                            productTotal + poctFee
                        ).toFixed(2);

                        const currentPaymentLoading =
                            paymentLoading[cart?._id];

                        const currentPaymentError =
                            paymentErrors[cart?._id];

                        return (
                            <div
                                key={cart?._id}
                                className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-2xl shadow-lg mb-12 p-8 transition hover:shadow-2xl"
                            >
                                {/* SİFARİŞ MƏLUMATLARI */}
                                <div className="grid md:grid-cols-4 gap-6 border-b border-gray-200 dark:border-gray-700 pb-6 mb-6">
                                    {/* ÖDƏNİŞ VƏZİYYƏTİ */}
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Ödəniş vəziyyəti
                                        </p>

                                        <p
                                            className={`text-xl font-semibold ${
                                                cart.paymentStatus === "pending"
                                                    ? "text-blue-600 dark:text-blue-400"
                                                    : ""
                                            } ${
                                                cart.paymentStatus === "paid"
                                                    ? "text-green-600 dark:text-green-400"
                                                    : ""
                                            } ${
                                                cart.paymentStatus !==
                                                    "pending" &&
                                                cart.paymentStatus !== "paid"
                                                    ? "text-red-600 dark:text-red-400"
                                                    : ""
                                            }`}
                                        >
                                            {cart.paymentStatus === "pending"
                                                ? "Ödəniş gözlənilir"
                                                : cart.paymentStatus === "paid"
                                                ? "Ödəniş tamamlanıb"
                                                : "Ödəniş edilməyib"}
                                        </p>
                                    </div>

                                    {/* SİFARİŞ KODU */}
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Sifariş kodu
                                        </p>

                                        <p className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                                            {cart.orderCode || "Məlumat yoxdur"}
                                        </p>
                                    </div>

                                    {/* TƏSDİQLƏNMƏ TARİXİ */}
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Təsdiqlənmə tarixi
                                        </p>

                                        <p className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                                            {cart.confirmedAt ||
                                                "Məlumat yoxdur"}
                                        </p>
                                    </div>

                                    {/* MƏHSUL SAYI */}
                                    <div>
                                        <p className="text-sm text-gray-500 dark:text-gray-400">
                                            Məhsul sayı
                                        </p>

                                        <p className="text-xl font-semibold text-gray-800 dark:text-gray-100">
                                            {products.length} məhsul
                                        </p>
                                    </div>
                                </div>

                                {/* ÖDƏNİŞ MƏLUMATI XƏTASI */}
                                {currentPaymentError && (
                                    <div className="mb-6 rounded-2xl border border-yellow-200 dark:border-yellow-900 bg-yellow-50 dark:bg-yellow-950/30 p-5">
                                        <div className="flex items-start gap-3">
                                            <FaExclamationTriangle className="text-yellow-600 dark:text-yellow-400 mt-1 flex-shrink-0" />

                                            <div>
                                                <p className="font-semibold text-yellow-800 dark:text-yellow-300">
                                                    Ödəniş məlumatı alınmadı
                                                </p>

                                                <p className="text-sm text-yellow-700 dark:text-yellow-400 mt-1">
                                                    Bu sifariş üzrə ödəniş
                                                    məlumatlarının alınması
                                                    zamanı problem yarandı.
                                                </p>

                                                <div className="mt-3 p-3 rounded-lg bg-white dark:bg-gray-900 border border-yellow-200 dark:border-yellow-800">
                                                    <p className="text-xs font-semibold text-gray-600 dark:text-gray-300">
                                                        Xətanın səbəbi:
                                                    </p>

                                                    <p className="text-sm text-gray-700 dark:text-gray-400 mt-1 break-words">
                                                        {currentPaymentError}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ÖDƏNİŞ MƏLUMATLARI YÜKLƏNİR */}
                                {currentPaymentLoading && (
                                    <div className="mb-6 flex items-center gap-3 rounded-xl bg-blue-50 dark:bg-blue-950/30 border border-blue-200 dark:border-blue-900 p-4">
                                        <FaSpinner className="animate-spin text-blue-600 dark:text-blue-400" />

                                        <div>
                                            <p className="font-semibold text-blue-800 dark:text-blue-300">
                                                Ödəniş məlumatları yüklənir...
                                            </p>

                                            <p className="text-sm text-blue-700 dark:text-blue-400">
                                                Bu sifariş üzrə ödəniş
                                                məlumatları yoxlanılır.
                                            </p>
                                        </div>
                                    </div>
                                )}

                                {/* MƏHSULLAR */}
                                <div className="overflow-x-auto border-b border-gray-200 dark:border-gray-700 pb-6 mb-6">
                                    <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
                                        Sifarişdəki məhsullar
                                    </p>

                                    <p className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
                                        {products.length} məhsul
                                    </p>

                                    {products.length > 0 ? (
                                        <div className="min-w-[400px] max-h-[520px] overflow-y-auto">
                                            <table className="min-w-full text-sm text-left">
                                                <thead className="bg-gray-100 dark:bg-gray-700 sticky top-0 z-10">
                                                    <tr>
                                                        <th className="px-4 py-2 text-gray-600 dark:text-gray-300">
                                                            Şəkil
                                                        </th>

                                                        <th className="px-4 py-2 text-gray-600 dark:text-gray-300">
                                                            Məhsulun adı
                                                        </th>

                                                        <th className="px-4 py-2 text-gray-600 dark:text-gray-300">
                                                            Say
                                                        </th>

                                                        <th className="px-4 py-2 text-gray-600 dark:text-gray-300">
                                                            Ümumi qiymət
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                                    {products.map((product) => {
                                                        const price =
                                                            Number(
                                                                product?.price
                                                            ) || 0;

                                                        const quantity =
                                                            Number(
                                                                product?.quantity
                                                            ) || 0;

                                                        const image =
                                                            Array.isArray(
                                                                product?.photo
                                                            )
                                                                ? product.photo[0]
                                                                : product?.photo;

                                                        return (
                                                            <tr
                                                                key={
                                                                    product?._id ||
                                                                    Math.random()
                                                                }
                                                            >
                                                                <td className="px-4 py-3">
                                                                    {image ? (
                                                                        <img
                                                                            src={
                                                                                image
                                                                            }
                                                                            alt={
                                                                                product?.title ||
                                                                                "Məhsul şəkli"
                                                                            }
                                                                            className="w-14 h-14 rounded-lg object-cover border"
                                                                        />
                                                                    ) : (
                                                                        <div className="w-14 h-14 flex flex-col gap-1 items-center justify-center bg-gray-100 dark:bg-gray-700 text-gray-400 border rounded">
                                                                            <FaBoxOpen />
                                                                            <span className="text-[9px]">
                                                                                Şəkil
                                                                                yoxdur
                                                                            </span>
                                                                        </div>
                                                                    )}
                                                                </td>

                                                                <td className="px-4 py-3 font-medium text-gray-800 dark:text-gray-200">
                                                                    {product?.title ||
                                                                        "Məhsul adı yoxdur"}
                                                                </td>

                                                                <td className="px-4 py-3 text-center text-gray-700 dark:text-gray-300">
                                                                    {quantity}
                                                                </td>

                                                                <td className="px-4 py-3 text-center text-green-600 dark:text-green-400 font-bold">
                                                                    {(
                                                                        price *
                                                                        quantity
                                                                    ).toFixed(
                                                                        2
                                                                    )}{" "}
                                                                    AZN
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : (
                                        <div className="py-8 text-center text-gray-500 dark:text-gray-400">
                                            Bu sifarişdə məhsul yoxdur.
                                        </div>
                                    )}
                                </div>

                                {/* ÇATDIRILMA MƏLUMATLARI */}
                                {userPayments[cart?._id]?.length > 0 && (
                                    <div className="max-w-7xl mx-auto overflow-x-auto mt-8 shadow-lg rounded-lg border dark:border-gray-700">
                                        <h2 className="text-2xl font-semibold mb-6 text-gray-800 dark:text-white text-center">
                                            Çatdırılma məlumatları
                                        </h2>

                                        <table className="w-full text-sm text-left border-collapse">
                                            <thead className="bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800">
                                                <tr>
                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Ad
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Soyad
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Şəhər
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Ünvan
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Telefon
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Qeyd
                                                    </th>

                                                    <th className="p-4 text-gray-700 dark:text-gray-200">
                                                        Poçt məlumatı
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                                                {userPayments[cart?._id].map(
                                                    (p, idx) => (
                                                        <tr
                                                            key={idx}
                                                            className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200"
                                                        >
                                                            <td className="p-4">
                                                                {p?.name ||
                                                                    "Məlumat yoxdur"}
                                                            </td>

                                                            <td className="p-4">
                                                                {p?.surname ||
                                                                    "Məlumat yoxdur"}
                                                            </td>

                                                            <td className="p-4">
                                                                {p?.city ||
                                                                    "Məlumat yoxdur"}
                                                            </td>

                                                            <td className="p-4">
                                                                {p?.adress ||
                                                                    "Məlumat yoxdur"}
                                                            </td>

                                                            <td className="p-4">
                                                                {p?.phone ||
                                                                    "Məlumat yoxdur"}
                                                            </td>

                                                            <td className="p-4">
                                                                {p?.description ||
                                                                    "Qeyd yoxdur"}
                                                            </td>

                                                            <td className="p-4 max-w-[100px] sm:max-w-[200px] break-words">
                                                                {p?.poct ? (
                                                                    p.poct.length >
                                                                    10 ? (
                                                                        <>
                                                                            <span>
                                                                                {p.poct.slice(
                                                                                    0,
                                                                                    10
                                                                                )}
                                                                                ...
                                                                            </span>

                                                                            <button
                                                                                type="button"
                                                                                onClick={() =>
                                                                                    setOpenPoct(
                                                                                        p.poct
                                                                                    )
                                                                                }
                                                                                className="block mt-1 text-blue-500 hover:text-blue-700 underline text-sm"
                                                                            >
                                                                                Ətraflı bax
                                                                            </button>
                                                                        </>
                                                                    ) : (
                                                                        p.poct
                                                                    )
                                                                ) : (
                                                                    "Poçt məlumatı yoxdur"
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}

                                {/* POÇT MƏLUMATI PƏNCƏRƏSİ */}
                                {openPoct && (
                                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4">
                                        <div className="relative bg-white dark:bg-gray-900 p-6 rounded-2xl max-w-md w-full shadow-2xl">
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setOpenPoct(null)
                                                }
                                                className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition"
                                                aria-label="Pəncərəni bağla"
                                            >
                                                <FaTimes />
                                            </button>

                                            <h2 className="text-xl font-semibold mb-4 text-gray-800 dark:text-white pr-10">
                                                Poçt məlumatı
                                            </h2>

                                            <div className="p-4 rounded-xl bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
                                                <p className="text-gray-800 dark:text-gray-200 break-words">
                                                    {openPoct}
                                                </p>
                                            </div>

                                            <button
                                                type="button"
                                                onClick={() =>
                                                    setOpenPoct(null)
                                                }
                                                className="mt-5 w-full bg-blue-600 text-white px-4 py-3 rounded-xl hover:bg-blue-700 transition font-semibold"
                                            >
                                                Bağla
                                            </button>
                                        </div>
                                    </div>
                                )}

                                {/* QİYMƏT MƏLUMATLARI */}
                                <div className="mt-6 space-y-2">
                                    <div className="text-right font-semibold dark:text-white text-gray-800">
                                        Məhsulların ümumi qiyməti:{" "}
                                        {productTotal.toFixed(2)} AZN
                                    </div>

                                    <div className="text-right text-blue-600 dark:text-blue-400">
                                        Çatdırılma haqqı:{" "}
                                        {poctFee.toFixed(2)} AZN
                                    </div>

                                    <div className="text-right font-bold text-xl text-green-700 dark:text-green-400 mt-2">
                                        Yekun məbləğ: {totalWithPoct} AZN
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </>
            ) : (
                /* SİFARİŞ YOXDUR */
                <div className="max-w-2xl mx-auto py-16 px-6 text-center rounded-2xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50">
                    <FaBoxOpen className="mx-auto text-5xl text-gray-400 mb-5" />

                    <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
                        Sifariş tapılmadı
                    </h2>

                    {searchTerm ? (
                        <>
                            <p className="mt-3 text-gray-500 dark:text-gray-400">
                                <span className="font-semibold">
                                    "{searchTerm}"
                                </span>{" "}
                                axtarışına uyğun təsdiqlənmiş sifariş tapılmadı.
                            </p>

                            <button
                                type="button"
                                onClick={() => setSearchTerm("")}
                                className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-gray-800 dark:bg-gray-700 text-white hover:bg-gray-900 dark:hover:bg-gray-600 transition"
                            >
                                <FaTimes />
                                Axtarışı təmizlə
                            </button>
                        </>
                    ) : (
                        <p className="mt-3 text-gray-500 dark:text-gray-400">
                            Hazırda təsdiqlənmiş sifarişiniz yoxdur.
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default Confirmed;
